/**
 * @param {object} params
 * @param {string} params.selector single element query e.g. #someInput
 * @returns {any|null} most times will return as string
 */
export const getInputElementValue = ({selector}) => getElementProperty(selector, 'value');

/**
 * Get text value of an element. Concatenates all text of element's children.
 * Ideally should only be called on leaf element nodes i.e. element with no children
 *
 * @param {object} params
 * @param {string} params.selector single element query e.g. .block-of-text
 * @returns {string|null}
 */
export const getTextElementValue = ({selector}) => getElementProperty(selector, 'textContent');

/**
 * @param {object} params
 * @param {string} params.selector single element query e.g. [data-field1]
 * @returns {object|null} object with all applicable values as strings or null if element not found
 */
export const getElementDataset = ({selector}) => getElementProperty(selector, 'dataset', false);

/**
 * Get dataset values for multiple elements
 *
 * @param {object} params
 * @param {string} params.selector single element query e.g. [data-field1]
 * @returns {object|null} object with all applicable values as strings or null if element not found
 */
export const getMultiElementDataset = ({selector}) => getElementProperty(selector, 'dataset', true);

/**
 * @param {object} params params set as an object to be able to make future backwards compatible changes
 * @param {string} params.selector single element query e.g. .item
 * @param {function(element)} params.getProperty callback function with element found passed in
 * e.g. (element) => element.innerHtml
 * @returns {any|null} most times will return as string. Returns null when no element found
 */
export const getPageElementValue = ({selector, getProperty}) => {
    const element = document.querySelector(selector);

    if (element == null) {
        return null;
    }

    return getProperty(element);
};

/**
 * Use function when you are having multiple attributes of the same name on the dom element
 *
 * @param {object} params params set as an object to be able to make future backwards compatible changes
 * @param {string} params.selector single element query e.g. .item
 * @param {function(element)} params.getProperty callback function with element found passed in
 * e.g. (element) => element.innerHtml
 * @returns {any|null} most times will return as array. Returns null when no element found
 */
export const getPageMultiElementsValue = ({ selector, getProperty }) => {
    const elements = document.querySelectorAll(selector);

    if (elements.length < 1) {
        return null;
    }

    const elementList = {};
    elements.forEach((item) => {
        const properties = getProperty(item);

        for (var property in properties) {
            if (elementList[property] !== undefined) {
                elementList[property].push(properties[property]);
            } else {
                elementList[property] = [properties[property]];
            }
        }
    });

    return elementList;
};

const getElementProperty = (selector, property, multipleElements) => {
    if (multipleElements) {
        return getPageMultiElementsValue({selector, getProperty: (element) => element[property]});
    }
    return getPageElementValue({selector, getProperty: (element) => element[property]});
};
